export function toMap(list, toKey = null) {
  if (toKey === null) {
    toKey = list;

    return (map, item) => {
      const key = toKey(item);

      if (map.hasOwnProperty(key)) {
        throw new Error(`Duplicate key when using toMap: ${key}`);
      }

      map[key] = item;
      return map;
    };
  }

  return list.reduce(toMap(toKey), {});
}

export function groupBy(list, toKey = null) {
  if (toKey === null) {
    toKey = list;

    return (map, item) => {
      const key = toKey(item);
  
      if (!map.hasOwnProperty(key)) {
        map[key] = [];
      }
  
      map[key].push(item);
      return map;
    };
  }
  
  return list.reduce(groupBy(toKey), {});
}

export function flatMap(list, nextList) {
  return list.concat(nextList);
}

export function areShallowEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  }

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) {
      return false;
    }

    return obj1.every((value, i) => value === obj2[i]);
  }

  if (typeof obj1 === 'object' && typeof obj2 === 'object') {
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);
  
    if (obj1Keys.length !== obj2Keys.length) {
      return false;
    }
  
    return obj1Keys.every(key => obj1[key] === obj2[key]);
  }
  
  return false;
}

export function unique(array) {
  if (array.length < 2) {
    return array;
  }
  
  return Object.keys(array.reduce((map, item) => {
    map[item] = (map[item] || 0) + 1;
    return map;
  }, {}));
}

export function formatNumber(num) {
  if (num === null || num === undefined || isNaN(num) || !isFinite(num)) {
    return "(no value)";
  }
  else if (num > 1e12) {
    return `${(num / 1e12).toLocaleString()}T`;
  }
  else if (num > 1e9) {
    return `${(num / 1e9).toLocaleString()}B`;
  }
  else if (num > 1e6) {
    return `${(num / 1e6).toLocaleString()}M`;
  }
  else if (num > 1e3) {
    return `${(num / 1e3).toLocaleString()}K`;
  }

  return num.toLocaleString();
}

export function isIE() {
  // Internet Explorer 6-11
  let isIE = /*@cc_on!@*/false || !!document.documentMode;

  // Edge 20+
  let isEdge = !isIE && !!window.StyleMedia;

  return isIE || isEdge;
}